module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion w-100"
  }, [_c('div', {
    staticClass: "accordion-header form-group",
    staticStyle: {
      "width": "fit-content"
    },
    on: {
      "click": _vm.toggleAccordion
    }
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n    "), (_vm.isOpen) ? _c('i', {
    staticClass: "f7-icons formChevron",
    style: ({
      color: _vm.chevronColor
    })
  }, [_vm._v(_vm._s(_vm.chevronOpen))]) : _vm._e(), _vm._v(" "), (!_vm.isOpen) ? _c('i', {
    staticClass: "f7-icons formChevron",
    style: ({
      color: _vm.chevronColor
    })
  }, [_vm._v(_vm._s(_vm.chevronClose))]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "accordion-v2"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "before-leave": _vm.beforeLeave,
      "leave": _vm.leave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "accordion-body",
    staticStyle: {
      "height": "auto !important"
    }
  }, [_c('div', {
    staticClass: "accordion-body-inner"
  }, [_vm._t("default")], 2)])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-54a914b3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54a914b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FormAccordionV2.vue
// module id = 2418
// module chunks = 2